import React, { useEffect, useRef, useState } from "react";

export default function InfoTooltip({ text, align = "right", subtle = false }) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!wrapRef.current) return;
      if (!wrapRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const panelClass =
    align === "left"
      ? "left-0"
      : align === "center"
      ? "left-1/2 -translate-x-1/2"
      : "right-0";

  return (
    <div
      ref={wrapRef}
      className="relative z-[80] overflow-visible"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          setOpen((prev) => !prev);
        }}
        className={
          subtle
            ? "inline-flex h-5 w-5 items-center justify-center rounded-full text-[12px] font-medium text-gray-300 transition hover:text-gray-500 dark:text-gray-600 dark:hover:text-gray-300"
            : "inline-flex h-7 w-7 items-center justify-center rounded-full border border-gray-200 bg-white/90 text-[13px] font-bold text-gray-500 transition hover:border-blue-200 hover:text-blue-600 dark:border-white/10 dark:bg-white/5 dark:text-gray-300 dark:hover:text-blue-300"
        }
        aria-label="설명 보기"
      >
        ?
      </button>

      {open && (
        <div
          className={`absolute top-full z-[90] mt-2 w-[240px] rounded-2xl border border-gray-200 bg-white px-3 py-3 text-[12px] font-medium leading-5 text-gray-600 shadow-xl dark:border-white/10 dark:bg-[#111827] dark:text-gray-200 ${panelClass}`}
        >
          {text}
        </div>
      )}
    </div>
  );
}